function toggleMenuDirectionButtons(buttonLeft, buttonRight, scrollContainer) {
  const scrollLeft = scrollContainer.scrollLeft;

  buttonLeft.parentElement.style.display = scrollLeft === 0 ? "none" : "block";
  buttonRight.parentElement.style.display = (scrollContainer.scrollWidth - scrollContainer.clientWidth <= scrollLeft) ? "none" : "block";
}

document.addEventListener("DOMContentLoaded", function() {
  const buttonLeft = document.querySelector('.menu-direction-prev__icon');
  const buttonRight = document.querySelector('.menu-direction-next__icon');
  const scrollContainer = document.getElementById("cavas_menu-navigation");

  toggleMenuDirectionButtons(buttonLeft, buttonRight, scrollContainer);

  buttonLeft.onclick = function () {
    scrollContainer.scrollBy({ left: -200, behavior: 'smooth' });
  };

  buttonRight.onclick = function () {
    scrollContainer.scrollBy({ left: 200, behavior: 'smooth' });
  };

  scrollContainer.addEventListener("scroll", () => {
    toggleMenuDirectionButtons(buttonLeft, buttonRight, scrollContainer);
  });
});